export default {
      id: "icon--events-usage",
      viewBox: "0 0 31.5 32.5",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--events-usage",
      toString: function () {
        return this.url;
      }
    }